import { Button, Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ApartmentIcon from '@material-ui/icons/Apartment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CardMessage from '../../../components/CardMessage/CardMessage';
import EmployeesListCard from '../../../components/EmployeesListCard';
import { AppState } from '../../../store';
import { CondominiumReducerData } from '../../../store/reducers/condominiumReducer';
import EmployeeSentNoticesTableCard from './components/EmployeeSentNoticesTableCard';
import SendNoticesDialog from './components/SendNoticesDialog';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContentContainer: {
      overflowX: 'hidden',
      display: 'flex',
      alignItems: 'start',
      overflowY: 'auto',
      margin: 0,
      width: '100%',
      height: 'calc(100vh - 152px)',
      padding: theme.spacing(1),

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'row',
      },
    },
    lowerContainer: {
      [theme.breakpoints.down('sm')]: {
        paddingTop: '16px',
      },
    },
    contentMaxHeight: {
      height: '100%',
    },
    purpleShortcutCard: {
      position: 'relative',
      minWidth: '230px',
      height: '100%',
      flex: 1,
    },
    cardIconRight: {
      position: 'absolute',
      top: 20,
      right: -2,
      fontSize: 40,
    },
  }),
);

const SendingNotices: React.FC = () => {
  const classes = useStyles();

  const [openSendNoticesDialog, setOpenNoticesDialog] = useState<boolean>(
    false,
  );

  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  return (
    <>
      <Grid className={classes.mainContentContainer} spacing={2} container>
        {condominiumSelected ? (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              className={classes.contentMaxHeight}
            >
              <EmployeesListCard
                title="Funcionários"
                titleTooltip="Clique no nome do funcionário para acessar os avisos já enviados"
                hideAllActionButtonsDefault
                selectableItemList
                customActionsButtons={
                  <Button
                    fullWidth
                    onClick={() => setOpenNoticesDialog(true)}
                    variant="contained"
                    color="primary"
                  >
                    Enviar para vários
                  </Button>
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={9}
              className={classes.contentMaxHeight}
            >
              <EmployeeSentNoticesTableCard />
            </Grid>
          </>
        ) : (
          <CardMessage
            icon={<ApartmentIcon style={{ fontSize: 130, opacity: 0.4 }} />}
            message="Selecione um condomínio"
          />
        )}
      </Grid>
      <SendNoticesDialog
        open={openSendNoticesDialog}
        handleCloseDialog={() => setOpenNoticesDialog(false)}
      />
    </>
  );
};

export default SendingNotices;
